__turbopack_context__.v({
  "Arrow": "v37Dxq_Arrow",
  "ArrowFill": "v37Dxq_ArrowFill",
  "ArrowInnerStroke": "v37Dxq_ArrowInnerStroke",
  "ArrowOuterStroke": "v37Dxq_ArrowOuterStroke",
  "Avatar": "v37Dxq_Avatar",
  "Button": "v37Dxq_Button",
  "Fallback": "v37Dxq_Fallback",
  "Image": "v37Dxq_Image",
  "Item": "v37Dxq_Item",
  "Popup": "v37Dxq_Popup",
  "Positioner": "v37Dxq_Positioner",
  "Separator": "v37Dxq_Separator",
  "SeparatorRow": "v37Dxq_SeparatorRow",
  "SeparatorWrapper": "v37Dxq_SeparatorWrapper",
  "absolute": "v37Dxq_absolute",
  "itemSub": "v37Dxq_itemSub",
  "notificationsCount": "v37Dxq_notificationsCount",
});
